import React from 'react';
import { Button } from 'bloomer';
import styled from 'styled-components';
import { colors } from '../../styles/colors';
import { ButtonStye } from '../../helpers/types';

export type CustomButtonProps = {
  onClick: () => void;
  loading?: boolean;
  buttonstyle?: ButtonStye;
};

export default class CustomButton extends React.PureComponent<CustomButtonProps> {
  render() {
    const { loading } = this.props;
    return <StyledButton isLoading={loading ? true : false} {...this.props}>{this.props.children}</StyledButton>;
  }
}
const StyledButton = styled(Button) <CustomButtonProps>`
  width:${props => props.buttonstyle?.isFullwidth ? '100%' : ''};
	border: 1px solid white;
	margin-left:${props => props.buttonstyle?.isFullwidth ? '0' : '2.6em'};
	padding-top:0.3em;
  color: ${props => props.buttonstyle ? props.buttonstyle.textColor : colors.primaryText};
	background-color: ${props => props.buttonstyle ? props.buttonstyle.backgroundColor : colors.red};
  font-weight: bold;
  transition: background-color 0.2s;
`;
